import type {RecipientResource} from 'src/types/survey';
import type {ReportStats} from 'src/types/report';
import type {ReportAction} from 'src/action-creators/report';
import {type AnalyticsQuery} from 'src/utils/analytics-query';

import {
  RECEIVE_AGENCY,
  RECEIVE_AGENCY_FOR_RECIPIENT,
  RECEIVE_WORKFLOW,
  RECEIVE_EVENT,
  SET_DEFAULT_QUERY,
} from 'src/action-creators/report';

import {parseLinks} from 'src/api-parsers/link-stats';


export type ReportState = {
  stats: ReportStats | null | undefined;
  clientStats: ReportStats | null | undefined;
  consultantStats: ReportStats | null | undefined;
  workflows: {
    [workflowId: string]: ReportStats;
  };
  events: {
    [eventId: string]: ReportStats;
  };
  defaultQuery: AnalyticsQuery | null | undefined;
};

const initialState = {
  stats: null,
  clientStats: null,
  consultantStats: null,
  workflows: Object.freeze({}),
  events: Object.freeze({}),
  defaultQuery: null,
} as const;

export default (
  state: ReportState = initialState,
  action: ReportAction,
): ReportState => {
  switch (action.type) {
    case RECEIVE_AGENCY:
      return {...state, stats: reduceReport(action.payload)};

    case RECEIVE_AGENCY_FOR_RECIPIENT:
      const updateKey = getAgencyRecipientUpdateKey(action.recipient);
      return {...state, [updateKey]: reduceReport(action.payload)};

    case RECEIVE_WORKFLOW:
      return {
        ...state,
        workflows: {
          ...state.workflows,
          [action.payload.workflowId]: reduceReport(action.payload),
        },
      };

    case RECEIVE_EVENT:
      return {
        ...state,
        events: {
          ...state.events,
          [action.payload.eventId]: reduceReport(action.payload),
        },
      };

    case SET_DEFAULT_QUERY:
      return {
        ...state,
        defaultQuery: action.payload,
      };
  }

  return state;
};

const reduceReport = (
  // @ts-expect-error TS2304
  report: WorkflowReportStats | EventReportStats | ReportStats,
) => ({
  ...report,
  links: report.links && parseLinks(report.links),
});

export const getAgencyRecipientUpdateKey = (
  recipient: RecipientResource,
): string =>
  ({
    client: 'clientStats',
    audience_member: 'consultantStats',
    internal: 'internalStats',
  }[recipient]);
